import { globalStyles } from 'shared/constants';
const { margin, padding, text, display, flex } = globalStyles;

const style = {
  paper: {
    ...padding(4),
  },
  wrapper: {
    ...display.flex,
    ...flex.justify.between,
  },
  title: {
    ...text.weight.bold,
    ...margin(2, 'Bottom')
  },
  downloadDialogPaper: {
    '& .MuiDialog-paper': {
      maxWidth: 416,
      minWidth: 416,
    } 
  },
  downloadDialogCloseIcon: {
    color: 'grey.400'
  },
  divider: {
    position: 'absolute',
    left: 0,
    right: 0,
  }
};

export default style;
